export default __webpack_public_path__ + "static/media/12.4c7cb5a5.jpg";